import { QueryEntity, EntityActions } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { CalendarEventsStore, CalendarEventsState } from './calendar-events.store';
import { switchMap, filter, first } from 'rxjs/operators';

@Injectable()
export class CalendarEventsQuery extends QueryEntity<CalendarEventsState> {
    filtered$ = this.selectAll();

    dateRange$ = this.select(state => state.ui.dateRange);

    typeIds$ = this.select(state => state.ui.typeIds);

    userIds$ = this.select(state => state.ui.userIds);

    selectSet$ = this.selectEntityAction()
        .pipe(
            filter(action => {
                return action.type === EntityActions.Set
            }),
            switchMap(action => this.selectMany(action.ids).pipe(first()))
        );

    constructor(protected store: CalendarEventsStore) {
        super(store);
    }
}